module.exports = __webpack_public_path__ + "img/p3.548c40c4.png";